<div class="text-xs font-bold uppercase text-gray-400 px-3">Meni</div>
<nav class="flex flex-col gap-1">
  <a
    class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-purple-50 hover:text-purple-700 transition-colors"
    routerLinkActive="bg-purple-100 text-purple-700 font-bold"
    [routerLink]="['/dashboard']"
  >
    <span class="text-base">🏠</span>
    <span>Početna</span>
  </a>
  <a
    class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-purple-50 hover:text-purple-700 transition-colors"
    routerLinkActive="bg-purple-100 text-purple-700 font-bold"
    [routerLink]="['/archive']"
  >
    <span class="text-base">🗂️</span>
    <span>Arhiva</span>
  </a>
  <a
    class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-purple-50 hover:text-purple-700 transition-colors"
    routerLinkActive="bg-purple-100 text-purple-700 font-bold"
    [routerLink]="['/daily-archive']"
  >
    <span class="text-base">📅</span>
    <span>Dnevna arhiva</span>
  </a>
  <a
    class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-purple-50 hover:text-purple-700 transition-colors"
    routerLinkActive="bg-purple-100 text-purple-700 font-bold"
    [routerLink]="['/monthly-stats']"
  >
    <span class="text-base">📊</span>
    <span>Mesečna statistika</span>
  </a>
  <a
    class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-purple-50 hover:text-purple-700 transition-colors"
    routerLinkActive="bg-purple-100 text-purple-700 font-bold"
    [routerLink]="['/daily-stats']"
  >
    <span class="text-base">📈</span>
    <span>Dnevna statistika</span>
  </a>
  <a
    class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-purple-50 hover:text-purple-700 transition-colors"
    routerLinkActive="bg-purple-100 text-purple-700 font-bold"
    [routerLink]="['/keywords']"
  >
    <span class="text-base">🔑</span>
    <span>Ključne reči</span>
  </a>
  <a
    class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-purple-50 hover:text-purple-700 transition-colors"
    routerLinkActive="bg-purple-100 text-purple-700 font-bold"
    [routerLink]="['/send-as-client']"
  >
    <span class="text-base">📨</span>
    <span>Pošalji kao klijent</span>
  </a>
</nav>
